var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discount-dollar-dash 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427321241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 29.5C15 30.9834 15.4399 32.4334 16.264 33.6668C17.0881 34.9002 18.2594 35.8614 19.6299 36.4291C21.0003 36.9968 22.5083 37.1453 23.9632 36.8559C25.418 36.5665 26.7544 35.8522 27.8033 34.8033C28.8522 33.7544 29.5665 32.418 29.8559 30.9632C30.1453 29.5083 29.9968 28.0003 29.4291 26.6299C28.8614 25.2594 27.9002 24.0881 26.6668 23.264C25.4334 22.4399 23.9834 22 22.5 22C21.0166 22 19.5666 21.5601 18.3332 20.736C17.0999 19.9119 16.1386 18.7406 15.5709 17.3701C15.0033 15.9997 14.8547 14.4917 15.1441 13.0368C15.4335 11.582 16.1478 10.2456 17.1967 9.1967C18.2456 8.14781 19.582 7.4335 21.0368 7.14411C22.4917 6.85472 23.9997 7.00325 25.3701 7.57091C26.7406 8.13856 27.9119 9.09986 28.736 10.3332C29.5601 11.5666 30 13.0166 30 14.5",
    stroke: "#979592",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5 2V7",
    stroke: "#979592",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.5 37V42",
    stroke: "#979592",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.e96afadb406c9e98c4a4afa557fd1df7.svg";
export { ForwardRef as ReactComponent };